<template>
    <div :class="$style.spinner"></div>
</template>

<script>
export default {
    name: "CircularButtonLoader",
};
</script>

<style module>
.spinner {
    border: 2px solid rgb(185, 185, 185);
    border-radius: 50%;
    border-top: 2px solid rgb(65, 65, 255);
    width: 18px;
    height: 18px;
    animation: spin 2s linear infinite;
}
</style>
